
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { FairClickUserCredits } from '@/types/fairclick';
import { CreditCard, ArrowUpRight, ArrowDownLeft, BarChart } from 'lucide-react';

interface CreditStatsProps {
  userCredits: FairClickUserCredits | null;
}

export const CreditStats = ({ userCredits }: CreditStatsProps) => {
  return (
    <Card className="w-full bg-white shadow-md">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <CreditCard size={20} className="text-primary" />
          Vos crédits FairClick
        </CardTitle>
        <CardDescription>
          Visitez des sites pour gagner des crédits
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex items-center space-x-4 p-3 bg-primary/5 rounded-lg">
            <div className="p-2 bg-primary/10 rounded-full">
              <CreditCard size={22} className="text-primary" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">Crédits disponibles</p>
              <h3 className="text-2xl font-bold text-primary">
                {userCredits?.credits || 0}
              </h3>
            </div>
          </div>
          
          <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
            <div className="p-2 bg-green-100 rounded-full">
              <ArrowUpRight size={22} className="text-green-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">Visites effectuées</p>
              <h3 className="text-2xl font-bold text-green-600">
                {userCredits?.total_visits_made || 0}
              </h3>
            </div>
          </div>
          
          <div className="flex items-center space-x-4 p-3 bg-orange-50 rounded-lg">
            <div className="p-2 bg-orange-100 rounded-full">
              <ArrowDownLeft size={22} className="text-orange-600" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-600">Visites reçues</p>
              <h3 className="text-2xl font-bold text-orange-600">
                {userCredits?.total_visits_received || 0}
              </h3>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
